import { faMessageQuestion } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ROLES } from '@moal/api'
import PropTypes from 'prop-types'
import { useContext, useState } from 'react'
import { AuthenticationContext } from '../../../context/authenticationContext'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import PostDate from '../../Utilities/PostDate'
import TextWrapper from '../../Utilities/TextWrapper'
import ActionPanel from '../ActionPanel'
import MessageEdited from './MessageEdited'
import ReplyTo from './ReplyTo'
import UserName from './UserName'

const Message = ({
  message,
  channel,
  expandedUserInfoWidget,
  setExpandedUserInfoWidget,
  modView,
  emphasize = true,
  emphasizeQuestions = false
}) => {
  const { user } = useContext(AuthenticationContext)
  const { setReplyTo } = useContext(SiteConfigContext)
  const [showActionPanel, setShowActionPanel] = useState(false)

  const handleReply = () => {
    setReplyTo(message)
  }

  const shouldEmphasizeQuestion = (message) => {
    return (
      modView &&
      emphasizeQuestions &&
      (message.message.includes('?') || message.questionRank)
    )
  }

  const roleClassesMap = {
    [ROLES.ADMIN]:
      'border-blue-200 dark:border-blue-900 from-blue-100 dark:from-blue-900/20 border-y py-1 bg-gradient-to-tl to-transparent',
    [ROLES.HOST]:
      'border-blue-200 dark:border-blue-900 from-blue-100 dark:from-blue-900/20 border-y py-1 bg-gradient-to-tl to-transparent',
    [ROLES.EXPERT]:
      'border-blue-200 dark:border-blue-900 from-blue-100 dark:from-blue-900/20 border-y py-1 bg-gradient-to-tl to-transparent',
    [ROLES.MODERATOR]:
      'border-orange-200 dark:border-orange-900 from-orange-100 dark:from-orange-900/20 border-y py-1 bg-gradient-to-tl to-transparent',
    default: ''
  }

  let roleClasses = emphasize
    ? roleClassesMap[message.user.role.role]
    : roleClassesMap.default

  if (user) {
    const { emphasizeStaffMessages } = user.userService.settings
    if (emphasizeStaffMessages) {
      roleClasses = emphasize
        ? roleClassesMap[message.user.role.role]
        : roleClassesMap.default
    } else {
      roleClasses = roleClassesMap.default
    }
  }

  return (
    <div className="w-full">
      {message.replyTo && <ReplyTo user={user} message={message.replyTo} />}
      <div
        className={`${roleClasses} relative break-words text-sm lg:text-base px-2`}
        key={message._id}
        onMouseEnter={() => setShowActionPanel(true)}
        onMouseLeave={() => setShowActionPanel(false)}
      >
        {user && user.userService.settings.showTimestamps && (
          <PostDate date={message.postdate} />
        )}
        {shouldEmphasizeQuestion(message) && (
          <FontAwesomeIcon
            className={`size-4.5 mr-2 ${message.questionRank ? `text-amber-500 ` : `text-neutral-700`}`}
            icon={faMessageQuestion}
          />
        )}
        <UserName
          message={message}
          user={user}
          expandedUserInfoWidget={expandedUserInfoWidget}
          setExpandedUserInfoWidget={setExpandedUserInfoWidget}
          modView={modView}
        />
        <span className="dark:text-neutral-50">
          <TextWrapper fromUser={message.user} text={message.message} />
          {message.edited && <MessageEdited />}
        </span>
        {channel && showActionPanel && (
          <ActionPanel channel={channel} handleReply={handleReply} />
        )}
      </div>
    </div>
  )
}

Message.propTypes = {
  message: PropTypes.object.isRequired,
  channel: PropTypes.string,
  expandedUserInfoWidget: PropTypes.string,
  setExpandedUserInfoWidget: PropTypes.func,
  modView: PropTypes.bool
}

export default Message
